export default function OpeningText() {
  return (
    <section
      id="inauguracao"
      className="relative w-full flex flex-col items-center justify-center text-center px-6 py-20 md:py-32"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-stone-950 via-stone-900 to-stone-950 -z-10" />

      <div className="max-w-3xl mx-auto">
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-stone-100 leading-[0.9] tracking-tight">
          INAUGURAÇÃO
        </h2>
        <h3 className="text-4xl md:text-6xl lg:text-7xl font-black text-amber-600 leading-[0.9] tracking-tight mt-2">
          EM BREVE
        </h3>

        <p className="mt-10 text-lg md:text-xl text-stone-400 max-w-2xl mx-auto leading-relaxed">
          Prepare-se para viver uma experiência única. O <strong className="text-stone-200">Jack's House Rock Bar</strong> está chegando com o melhor do rock, 
          ambiente refinado, aconchegante e familiar. 
          Uma atmosfera exclusiva para quem aprecia estilo, música e boa companhia.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contato"
            className="inline-flex items-center gap-2 px-8 py-4 bg-amber-700 hover:bg-amber-600 text-stone-100 font-semibold rounded-full transition-all hover:scale-105 whitespace-nowrap"
          >
            Fique por dentro
            <i className="ri-arrow-right-line" />
          </a>
          <span className="text-stone-500 text-sm">
            Abertura prevista: em breve
          </span>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl w-full">
        <div className="flex flex-col items-center gap-3 p-6 rounded-2xl bg-stone-900/50 border border-stone-800">
          <i className="ri-vip-crown-line text-3xl text-amber-500" />
          <span className="text-stone-300 font-medium">Ambiente Premium</span>
          <span className="text-stone-500 text-sm">Decoração exclusiva e atmosfera única</span>
        </div>
        <div className="flex flex-col items-center gap-3 p-6 rounded-2xl bg-stone-900/50 border border-stone-800">
          <i className="ri-goblet-line text-3xl text-amber-500" />
          <span className="text-stone-300 font-medium">Whiskey Selecionado</span>
          <span className="text-stone-500 text-sm">As melhores etiquetas do mundo</span>
        </div>
        <div className="flex flex-col items-center gap-3 p-6 rounded-2xl bg-stone-900/50 border border-stone-800">
          <i className="ri-music-2-line text-3xl text-amber-500" />
          <span className="text-stone-300 font-medium">Rock ao Vivo</span>
          <span className="text-stone-500 text-sm">As melhores bandas da cena</span>
        </div>
      </div>
    </section>
  );
}